import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'

const MutationMenuItem = ({useMutation, itemId, handleClose, title, Icon, translationKey}) => {
    const [doMutation] = useMutation()
    const {t} = useTranslation()

    const onClickHandler = () => {
        handleClose()

        toast.promise(
            doMutation(itemId)
                .unwrap()
                .then(() => {
                    console.log('Update successful')
                })
                .catch((error) => {
                    console.log('toast error', error)
                    throw error
                }),
            {
                loading: t('loading'),
                success: () => {
                    return t(`${translationKey}.success`)
                },
                error: () => {
                    return t(`${translationKey}.error`)
                },
            }
        )
    }
    return (
        <MenuItem key={`table_action_${itemId}`} onClick={onClickHandler}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t(`menuItem.${title}`)}</div>
                {Icon && <Icon />}
            </Box>
        </MenuItem>
    )
}

export default MutationMenuItem
